import { useSelector } from 'react-redux';
import { getActiveLocaleSelector, getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { useMembershipDomainFetchye } from '@americanexpress/consumer-travel-base';
import { hasVacationRentalsRule } from '../constants/featureConstants';
import { MODULE_NAME } from '../constants/modules';
import { MEMBERSHIP_QUERY } from '../graphql/membership';

export const useMembershipApi = () => {
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const activeLocale = useSelector(getActiveLocaleSelector);
  const hasVacationRentals = useConditionalFeature(hasVacationRentalsRule);

  const fetcherOpts = {
    locale: activeLocale,
    reporting: {
      moduleID: MODULE_NAME,
      component: 'useMembershipApi',
    },
  };

  const { data, isLoading, error } = useMembershipDomainFetchye(
    { query: MEMBERSHIP_QUERY },
    {
      defer: !(isLoggedIn && hasVacationRentals),
    },
    fetcherOpts
  );

  return { data, isLoading, error };
};
